module.exports = __webpack_public_path__ + "img/p3_4.52546fb3.webp";